import React from 'react';
import ModalButtons from '../ModalButtons/ModalButtons';
import numeral from 'numeral';

export default class ReservationSegmentCheckInConfirmationModal extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('check_in'),
        button_classes: ['primary'],
        onClick: (e) => {
          // debugger
          // $(window).trigger('check_in');
          $(parent).trigger('check_in')
          parent.hide_modal()
          return false;
        }
      }
    ];

    var source
    if(this.props.check_in_check_out_time_source == "rate") {
      source = I18n.t('set_in_rate')
    } else if (this.props.check_in_check_out_time_source == "override") {
      source = I18n.t('overridden_by_room')
    } else if (this.props.check_in_check_out_time_source == "reservation setting") {
      source = I18n.t('set_by_property_setting')
    }

    return(

      <div className="alert alert-dismissable alert-warning">
        {
          !this.props.past_check_in_time
            ?
            <h5 className="check-in-warning-header" >{`${this.props.check_in_time_message} (${source})`}</h5>
            :
            null
        }
        {
          !this.props.incidental_taken
          ?
          [
            // <h5 className="check-in-warning-header"  key='h5'>{I18n.t('check_in_warning')}:</h5>,
              <h5 className="check-in-warning-header" key='p'>
              <label key='label' style={{ marginBottom: 0 }}>{I18n.t('incidental_auth_due')}:</label>&nbsp;
              {this.formatCurrency(this.props.incidental_deposit_amount)}
            </h5>
          ]
          :
          null
        }
        {
          this.props.payment_due_amount > 0
          ?
          [
            // <h5 className="check-in-warning-header"  key='h5'>{I18n.t('check_in_warning')}:</h5>,
            <h5 className="check-in-warning-header" key='p'>
              <label key='label' style={{ marginBottom: 0 }}>{I18n.t('payment_due')}:</label>&nbsp;
              {this.formatCurrency(this.props.payment_due_amount)}
            </h5>
          ]
          :
          null
        }
        <ModalButtons buttons={buttons} />
      </div>
    );
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };
};
